import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "app-assignment-detail"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("任务管理");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("任务详情");

const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "item"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务名称：", -1);

const _hoisted_7 = {
  key: 0,
  class: "item"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务客户数：", -1);

const _hoisted_9 = {
  class: "item"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "培训课程：", -1);

const _hoisted_11 = {
  key: 0,
  class: "item"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "培训试卷：", -1);

const _hoisted_13 = {
  class: "item"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "陈列展示效果图：", -1);

const _hoisted_15 = {
  class: "imgs"
};
const _hoisted_16 = {
  class: "item"
};

const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "陈列教程：", -1);

const _hoisted_18 = {
  class: "imgs"
};
const _hoisted_19 = ["href"];
const _hoisted_20 = {
  class: "item"
};

const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务时间：", -1);

const _hoisted_22 = {
  class: "item"
};

const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "达成奖励：", -1);

const _hoisted_24 = {
  class: "member-process"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "任务成员进度详情", -1);

const _hoisted_26 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_27 = {
  key: 0
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { get } from 'lodash-es';
import { taskDetail, taskUserRecord } from '@/request';
export default {
  name: 'detail',

  setup(__props) {
    const route = useRoute();
    onMounted(() => getDetail());
    const taskTypeText = {
      1: '拜访任务',
      2: '陈列任务',
      3: '会议邀约任务',
      4: '培训学习',
      5: '培训考试'
    };
    const taskTypeTableText = {
      1: '拜访客户数',
      2: '陈列客户数',
      3: '邀约数量',
      4: '学习进度',
      5: '考试状态'
    };
    const img = ref('https://wyc-fe-static.yun-sk.com/static/wyt/web-logo-big.png');
    const detail = ref({});
    const loading = ref(true);

    function getDetail() {
      taskDetail({
        taskId: route.query.taskId
      }).then(res => {
        if (!res.success) return;
        detail.value = res.data;
      }).finally(() => loading.value = false);
    }

    function getImages(imgStr) {
      if (!imgStr) return;
      return imgStr.split(',');
    }

    const table = ref([]);
    const processModalShow = ref(false);

    function checkUserDetail(row) {
      let params = {
        supUserId: row.supUserId,
        taskId: route.query.taskId
      };
      taskUserRecord(params).then(res => {
        if (!res.success) return;
        table.value = res.data;
        processModalShow.value = true;
      });
    }

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'assignment'
            }
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        class: "detail"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(taskTypeText[detail.value.taskType]), 1), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(detail.value.taskName), 1)]), detail.value.taskType != 4 && detail.value.taskType != 5 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(detail.value.custNum), 1)])) : _createCommentVNode("", true), detail.value.taskType == 4 || detail.value.taskType == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(detail.value.trainingCourseName || '-'), 1)]), detail.value.taskType == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(detail.value.trainingPaperName || '-'), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), detail.value.taskType == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.sampleImage.split(','), (url, index) => {
          return _openBlock(), _createBlock(_component_el_image, {
            src: url,
            style: {
              "width": "100px",
              "height": "100px",
              "margin-right": "10px"
            },
            previewSrcList: getImages(detail.value.sampleImage),
            "initial-index": index
          }, null, 8, ["src", "previewSrcList", "initial-index"]);
        }), 256))])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [detail.value.courseType == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(detail.value.courseImage.split(','), (url, index) => {
          return _openBlock(), _createBlock(_component_el_image, {
            src: url,
            style: {
              "width": "100px",
              "height": "100px",
              "margin-right": "10px"
            },
            previewSrcList: getImages(detail.value.courseImage),
            "initial-index": index
          }, null, 8, ["src", "previewSrcList", "initial-index"]);
        }), 256)) : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: detail.value.courseVideo,
          style: {
            "color": "#409eff"
          },
          target: "_blank"
        }, _toDisplayString(detail.value.courseVideo), 9, _hoisted_19))])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, _toDisplayString(_unref(get)(detail.value, 'startTime', '').split(' ')[0]) + "~" + _toDisplayString(_unref(get)(detail.value, 'endTime', '').split(' ')[0]), 1)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", null, _toDisplayString(detail.value.rewardDesc || '无'), 1)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createVNode(_component_el_table, {
        data: detail.value.taskUserList || []
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: `团队成员(人数：${_unref(get)(detail.value, 'taskUserList.length', 0)})`,
          prop: "linkMan"
        }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
          label: `${taskTypeTableText[detail.value.taskType]}`,
          prop: "custNum"
        }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
          label: "完成状态",
          prop: "isFinish"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.isFinish == '0' ? '未完成' : '已完成'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "完成详情"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: $event => checkUserDetail(scope.row)
          }, {
            default: _withCtx(() => [_hoisted_26]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_dialog, {
        modelValue: processModalShow.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => processModalShow.value = $event),
        title: "完成详情",
        width: "700px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: table.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "客户名称",
            prop: "custName"
          }), _createVNode(_component_el_table_column, {
            label: detail.value.type == 3 ? '报名时间' : '完成时间',
            prop: "overTime"
          }, null, 8, ["label"]), detail.value.taskType == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "报名联系方式",
            prop: "linkPhone"
          })) : (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "图片"
          }, {
            default: _withCtx(scope => [scope.row.pictureUrls ? (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.pictureUrls.split(','), (url, index) => {
              return _openBlock(), _createBlock(_component_el_image, {
                src: url,
                style: {
                  "width": "90px",
                  "height": "90px",
                  "margin-right": "10px"
                },
                previewSrcList: getImages(scope.row.pictureUrls),
                "initial-index": index
              }, null, 8, ["src", "previewSrcList", "initial-index"]);
            }), 256))])) : _createCommentVNode("", true)]),
            _: 1
          }))]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};